import React from "react"
import { useTranslation } from "react-i18next"
import Flex from "@/components/Flex"
import Text from "@/components/Text"

export const DisclaimerSection = ({
  disclaimer,
}: {
  disclaimer: string | null
}) => {
  const { t } = useTranslation("payCustomer")

  if (!disclaimer) return null

  return (
    <Flex
      backgroundColor={"#0B1426"}
      flexDirection={"column"}
      p={["64px 16px", "56px 64px", "88px 180px"]}
      borderBottom="1px solid #323C52"
    >
      <Text
        color="#F4F4F4"
        fontSize="18px"
        fontWeight={550}
        lineHeight={"120%"}
        textAlign="start"
        mb={["32px", "32px", "8px"]}
      >
        {t("disclaimer.title")}
      </Text>
      <Text
        color="#565F76"
        fontSize="13px"
        fontWeight={400}
        lineHeight={"120%"}
        textAlign="start"
        maxWidth={["340px", "640px", "100%"]}
      >
        {t(disclaimer)}
      </Text>
    </Flex>
  )
}
